'use strict';

import $ from 'jquery';
import axios from 'axios';

let ContactForm = function ($el, opts) {
    this.$el = $el;
    this.opts = $.extend(true, {}, ContactForm.defaults, this.$el.data(), opts || {});

    this.init();
    this.action = this.$el.data('action') || window.location.href;
};

ContactForm.prototype.init = function () {

    /**
     * Register Event handlers here
     */

    $(this.$el).on('submit', (event) => {
        event.preventDefault();
        this.$el.find('input[type="submit"]').val("Sending ...");
        this.$el.find('input[type="submit"]').prop( "disabled", true );
        if (this.$el.parsley().isValid() || this.$el.parsley.isValid) {

            const data = this.toJSON(this.$el.serializeArray());
            this.submit(data);
        }

        return false;
    });

    this.$el[0].dataset.initialised = true;
};

ContactForm.prototype.submit = function (data) {

    const config = {
        headers: {
            'Content-Type': 'application/json; charset=utf-8'
        }
    };

    axios.post(this.action, data, config).then((response) => {

        const msg = response.data.msg;

        switch (response.status) {

            case 200:

                let success = this.$el.parent().find('.success');
                //success.find('.msg').text(msg);
                success.removeClass('d-none');
                this.$el.hide();
                break;

            case 500:

                let error = this.$el.parent().find('.error');
                //error.find('.msg').text(msg);
                error.removeClass('d-none');
                break;

            default:
                break;
        }

    }).catch((error) => {
        console.log(error);
    }).finally(() => {
        this.$el.parent().find('.result').removeClass('d-none');
        this.$el.find('input[type="submit"]').val("Submit");
        this.$el.find('input[type="submit"]').prop( "disabled", true );
        return false;     
    });
    return false;
};

ContactForm.prototype.toJSON = function (data) {

    let obj = {};

    data.forEach((input) => {
        obj[input.name] = input.value;
    });

    return obj;
};

ContactForm.defaults = {};

ContactForm.init = function (el) {
    return new ContactForm(el);
};

export default ContactForm;